// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseButton-root-1kuYh buttonReset-buttonReset-3FCx6","keyboardFocus":"BaseButton-keyboardFocus-2p_k4","mouseHover":"BaseButton-mouseHover-1st7J"};